
export const data = [
    {
        head:"Hot",
        day:"0 day ago",
        pos:"Senior Product Manager",
        com:"MasterCard",
        img1:"u",
        img2:"t",
        ex:" 4 to 6 years",
        cty:"Noida",
        ft1:"Be an Early Applicant",
        ft2:"Regular",
        id:1

    },
    {
        head:"Hot",
        day:"0 day ago",
        pos:"Computer Scientist I",
        com:"Adobe System",
        img1:"u",
        img2:"t",
        ex:" 2 to 5 years",
        cty:"Mumbai",
        ft1:"Be an Early Applicant",
        ft2:"Regular",
        id:2
    },
       {  head:"Hot",
        day:"0 day ago",
        pos:"Manager ,Portfolio Credit (L 09)",
        com:"Adobe System",
        img1:"u",
        img2:"t",
        ex:" 1 to 5 years",
        cty:"Bangalore",
        ft1:"Be an Early Applicant",
        ft2:"Regular",
        id:3
},
{
    head:"Hot",
    day:"0 day ago",
    pos:"Manager ,Capaign Operations (L 09)",
    com:"Synchrony Int",
    img1:"u",
    img2:"t",
    ex:" 3 to 7 years",
    cty:"Hydrabad",
    ft1:"Be an Early Applicant",
    ft2:"Regular",
    id:4
},
{
    head:"Hot",
    day:"0 day ago",
    pos:"Manager ,FSD ,Controllership (L 09)",
    com:"MasterCard",
    img1:"u",
    img2:"t",
    ex:" 4 to 6 years",
    cty:"Kolkata",
    ft1:"Be an Early Applicant",
    ft2:"Regular",
    id:5
}
]